export const presets  = {
  free: ["fspb-green", "fspb-red", "fspb-orange", "fspb-blue"],
  pro: ["fspb-green-blue", "fspb-pink-magenta", "fspb-purple", "fspb-brushed-steel", "fspb-carbon", "fspb-midnight", "fspb-cloud", "fspb-pastel", "fspb-salmon", "fspb-dream", "fspb-gum", "fspb-cream", "fspb-sky", "fspb-lake", "fspb-egg", "fspb-mars", "fspb-yolk", "fspb-ruby", "fspb-emerald", "fspb-jade", "fspb-bronze"],
}

export default {
    presets,
}
